export const isConsentExpired = (consentExpirationDate?: string | null) => {
  if (!consentExpirationDate) {
    return false
  }

  return new Date(consentExpirationDate).getTime() <= Date.now()
}

export const ellipsisCandidateData = (value: string | undefined | null, maxLength = 30) =>
  value && (value.length > maxLength ? `${value.substring(0, maxLength)}...` : value)
